import { GridValueFormatterParams } from "@mui/x-data-grid-pro";

const yesNoFormatter = ({ value }: GridValueFormatterParams) => value ? 'Yes' : 'No';

export default yesNoFormatter;